import React from "react"
import { PlayerIdentity } from "components/ReviewAudit/PublicRatings"
import { Seed } from "./GroupList"
import { accountNumber } from "../../../components/participantIdentity"
import { drawSections } from "./DrawSection"
import {
  feedingMatch,
  matchesSearch,
  participantName,
  Schedule,
  Scores,
  sideWaits,
  waitsForEarlierResult,
} from "./MatchCard"

const Team = ({ row, role, markWinner = false }) => (
  <div className="main-draw-search-team">
    {markWinner && row.winner === role && (
      <span
        className="main-draw-search-winner text-success"
        role="img"
        aria-label={row[`${role}Partner`] ? "Winning team" : "Winner"}
        title="Winner"
      >
        ✓
      </span>
    )}
    <div>
      {waitsForEarlierResult(row, row[role]) ? (
        <div>Winner of match {feedingMatch(row, role)}</div>
      ) : [row[role], row[`${role}Partner`]].filter(Boolean).map((person, i) => (
        <div key={i}>
          <PlayerIdentity player={person} to={person.id || person._id ? `/accounts/players/${person.id || person._id}` : null} linkProps={{ target: "_blank", rel: "noopener noreferrer" }}>{participantName(person)} {i === 0 && <Seed person={person} />}{accountNumber(person) != null && ` #${accountNumber(person)}`}</PlayerIdentity>
        </div>
      ))}
    </div>
  </div>
)
export default function ParticipantMatches({
  mainDraw,
  drawType,
  query,
  eventDetails,
  onEdit,
}) {
  if (!query.trim()) return null
  const sections = [
    ...drawSections(mainDraw, drawType),
    ...(drawType === "groups" && mainDraw.phases?.length
      ? drawSections(mainDraw, "eliminatory").map(section => ({
          ...section,
          phase: true,
        }))
      : []),
  ]
  const results = sections.flatMap(section =>
    section.rows
      .filter(row => row.type !== "TBA" && matchesSearch(row, query))
      .map(row => ({ row, label: section.label, phase: section.phase }))
  )
  return (
    <section
      className="main-draw-search-results"
      aria-label="Participant search results"
    >
      <h3>Participant matches</h3>
      <p role="status">
        {results.length
          ? `${results.length} matching matches`
          : "No matching matches"}
      </p>
      {results.length > 0 && (
        <div
          className="table-responsive"
          tabIndex={0}
          role="region"
          aria-label="Scroll participant matches"
        >
          <table className="table table-sm" aria-label="Participant matches">
            <thead>
              <tr>
                {[
                  "Match",
                  "Player / team",
                  "Opponent / team",
                  "Score",
                  "Result",
                  "Schedule",
                  "Actions",
                ].map(label => (
                  <th scope="col" key={label}>
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {results.map(({ row, label, phase }) => (
                <tr key={row._id}>
                  <th scope="row">
                    {label}
                    <small>Match {row.competition?.position ?? "—"}</small>
                  </th>
                  <td>
                    <Team row={row} role="player" markWinner />
                  </td>
                  <td>
                    <Team row={row} role="opponent" markWinner />
                  </td>
                  <td>
                    {["player", "opponent"].map(role => (
                      <Scores
                        key={role}
                        person={row[role]}
                        noOfSets={row.noOfSets}
                      />
                    ))}
                  </td>
                  <td>
                    {row.winner ? (
                      <>
                        Winner: <Team row={row} role={row.winner} />
                      </>
                    ) : (
                      "No winner recorded"
                    )}
                  </td>
                  <td>
                    <Schedule
                      scheduler={row.scheduler}
                      timezone={eventDetails?.timezone}
                    />
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-sm btn-light"
                      disabled={sideWaits(row)}
                      onClick={() => onEdit(row._id, phase)}
                    >
                      Edit match
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
